import { Injectable } from '@angular/core';
import { DataDefinitionOptions } from '../../../models/customer-space.model';

@Injectable({
  providedIn: 'root'
})
export class MeasureTaskService {
  constructor() { }
}
